/** Keith's Haircenter — green-forward brand palette (client specified “Green”). */
const colors = {
  black: '#000000',
  white: '#FFFFFF',
  /** Header ribbon / logo field — client brand green. */
  brand: {
    ribbon: '#136538'
  },
  primary: {
    main: '#2E7D32',
    100: '#E8F5E9',
    150: '#DCF2DE',
    200: '#C8E6C9',
    250: '#A5D6A7',
    300: '#81C784',
    500: '#43A047'
  },
  secondary: {
    main: '#33691E',
    100: '#F1F8E9',
    150: '#E8F0D8',
    175: '#DCEDC8',
    200: '#C5E1A5',
    400: '#7CB342',
    500: '#558B2F',
    600: '#33691E',
    800: '#1B5E20'
  },
  gray: {
    50: '#F8F7F6',
    100: '#F6F2F4',
    115: '#ECE7EB',
    125: '#E0E0E0',
    150: '#D0D0D0',
    200: '#C6C6C6',
    225: '#BFBFBF',
    230: '#919191',
    250: '#999999',
    260: '#979797',
    275: '#777777',
    300: '#666666',
    325: '#726B70',
    350: '#707070',
    375: '#5B5B5B',
    400: '#555555',
    425: '#4F4F4F',
    450: '#444444',
    500: '#404040',
    550: '#363636',
    600: '#2D2E2D',
    800: '#222222'
  },
  red: {
    100: '#FAE4E5',
    200: '#771414',
    300: '#A75348',
    400: '#C73D3D',
    500: '#E31B23',
    600: '#9D2D2D',
    700: '#B40000',
    800: '#A82026',
    900: '#A80909'
  },
  blue: {
    main: '#464DEA',
    200: '#9192A3',
    300: '#365CFF',
    400: '#6D6E71',
    800: '#121C2B'
  },
  blackOpacity: {
    10: 'rgba(0, 0, 0, 0.1)',
    16: 'rgba(0, 0, 0, 0.16)'
  },
  whiteOpacity: {
    17: 'rgba(255, 255, 255, 0.17)',
    80: 'rgba(255, 255, 255, 0.80)'
  },
  secondaryOpacity: {
    30: 'rgba(51, 105, 30, 0.3)',
    90: 'rgba(51, 105, 30, 0.9)'
  },
  redOpacity: {
    5: 'rgba(180, 0, 0, 0.05)',
    50: 'rgba(227, 27, 35, 0.5)'
  },
  grayOpacity: {
    90: 'rgba(34, 34, 34, 0.9)'
  }
};

export default colors;
